// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.openCloseAnimWrapperCss_oud8i6w:focus{outline:none;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-ui/dist/es/open-close-animation/OpenCloseAnimation.css"],"names":[],"mappings":"AAAA,uCAAuC,YAAY,CAAC","sourcesContent":[".openCloseAnimWrapperCss_oud8i6w:focus{outline:none;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
